import { createAction, handleActions } from 'redux-actions'

export const setUserTestFeature = createAction('SET_USER_TEST_FEATURE')

const initialState = {}

export default handleActions(
	{
		SET_USER_TEST_FEATURE: (state, action) => {
			return { ...state, [action.payload.feature_id]: action.payload }
		},
	},
	initialState
)
